import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
const imageStyles = css({
  maxWidth: '100%',
  height: 'auto'
});
const actionItemContainerStyles = css({
  display: 'flex',
  margin: `${"var(--ds-space-0, 0px)"} -4px`,
  /* When there is more than one action, place primary action visually on the
   right, but keep it's position as the first focusable element in the DOM */
  flexDirection: 'row-reverse'
});
const actionItemStyles = css({
  margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
/**
 * __Dialog image__
 *
 * An optional header image in spotlight dialogs.
 *
 * @internal
 */
export const DialogImage = ({
  alt,
  ...props
}) =>
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
jsx("img", _extends({
  css: imageStyles,
  alt: alt
}, props));

/**
 * __Dialog action item container__
 *
 * Flex wrapper around dialog action items.
 *
 * @internal
 */
export const DialogActionItemContainer = ({
  children
}) => jsx("div", {
  css: actionItemContainerStyles
}, children);

/**
 * __Dialog action item__
 *
 * Action items shown inside of the dialog.
 *
 * @internal
 */
export const DialogActionItem = ({
  children
}) => jsx("div", {
  css: actionItemStyles
}, children);